export enum AppPromotionPlatform {
    GooglePlay = 'googlePlay',
    AppStore = 'appStore',
}
